import { createFileRoute } from "@tanstack/react-router";

import { RecurrenceCreateHeader } from "@/components/recurring-appointment/recurrence-create-header";
import { RecurrenceNewPatientForm } from "@/components/recurring-appointment/recurrence-new-patient-form";
import { Page } from "@/components/ui/layout/page/page";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout";

import type { JSX } from "react";

const RecurringAppointmentNewPatientPage = (): JSX.Element => {
  return (
    <RoundedLayout>
      <RecurrenceCreateHeader title="Novo paciente" />
      <Page>
        <RecurrenceNewPatientForm />
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute("/recurring-appointments/create/patient")({
  component: RecurringAppointmentNewPatientPage,
});
